import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import { MediaQuery as MQ } from '../../shared/media-query';
const tid = 'MQNLOFW5';

class Component extends BaseComponent {
    constructor(props) {
        super(props);

        props.requirePsychics();

        this.keen_url = new URL('https://www.keen.com/landingpage/psychic-readings');
        this.keen_url.searchParams.set('u', tid);
        this.keen_url.searchParams.set('cat', '195');
        this.keen_url.searchParams.set('d', 'p');
        this.keen_url.searchParams.set('t', 'singleoffer104alt');
        this.keen_url.searchParams.set('utm_source', 'tarotcom');
        this.keen_url.searchParams.set('utm_medium', 'b2b');
        this.keen_url.searchParams.set('utm_campaign', 'general');
        this.keen_url.searchParams.set('utm_term', 'ptod_api');
        this.keen_url.searchParams.set('utm_content', '5min1');
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.psychics != this.props.psychics) {
            return true;
        }

        return false;
    }

    render({ psychics }) {
        if (psychics && Object.keys(psychics).length) {
            return (
                <keen>
                    <row className='is-wrap is-justified-center'>
                        <column className='is-5 is-7-mobile'>
                            <h3>
                                Find clarity.
                            </h3>
                            <h3>
                                Feel empowered.
                            </h3>
                        </column>
                        <column className='is-3 is-5-mobile has-padding-5-left-mobile'>
                            <p className='small is-inline'>
                                Powered by
                            </p>
                            <img className='keen-logo' src="https://gfx.tarot.com/images/site/tarot/keen/keen-logo.gif"/>
                        </column>
                    </row>
                    <row className='is-wrap is-justified-center has-margin-20-bottom'>
                        <column className='is-8 is-12-mobile'>
                            <p>
                                For nearly 25 years, Keen has helped over 14 million people find peace of
                                mind through 45+ million sessions with trusted, world-class Advisors.
                                Our secure, personalized guidance empowers you to move forward with
                                confidence — all backed by our 100% satisfaction guarantee. Keen is
                                where insight meets inspiration.
                            </p>
                        </column>
                    </row>
                    <row className='is-wrap is-justified-around'>
                        {Object.keys(psychics).map(key => this.renderPsychic(psychics[key], key))}
                    </row>
                </keen>
            );
        }

        return (<keen {...this.props} />); //eslint-disable-line tarot/no-direct-props-access-in-render
    }

    renderPsychic = (psychic, key) => {
        const psychic_url = new URL(`https://www.keen.com${psychic.detailsUrl}`);
        psychic_url.searchParams.set('tid', tid);
        psychic_url.searchParams.set('utm_source', 'tarotcom');
        psychic_url.searchParams.set('utm_medium', 'b2b');
        psychic_url.searchParams.set('utm_campaign', 'general');
        psychic_url.searchParams.set('utm_term', 'ptod_api');
        psychic_url.searchParams.set('utm_content', '5min1');

        return (
            <column className='is-6 is-12-mobile has-margin-10-top-mobile'>
                <a
                    className='keen-listing-container'
                    key={key}
                    href={psychic_url}
                    target='_blank'
                    rel='noopener sponsored noreferrer'
                    onClick={() => this.props.trackEvent([
                        'Click',
                        `Psychics_LP:${key}_Card`,
                    ])}
                >
                    <div className='keen-listing-price-container'>
                        <div className='offer-text'>
                        5 minutes for $1
                        </div>
                        <div className='listing-price'>
                            {psychic.serviceRate}/min
                        </div>
                    </div>
                    <row className='is-wrap is-aligned-center has-margin-20-bottom'>
                        <column className='is-6 is-flex is-justified-center'>
                            <div className='keen-image-container'>
                                <img
                                    src={psychic.picture.size500Version
                                        ? psychic.picture.size500Version.url
                                        : psychic.pictureURL}
                                    alt={psychic.speakerName}
                                    loading='lazy'
                                    className='keen-psychic'
                                    width='165'
                                    height='165'
                                />
                                <div className='dot' />
                            </div>
                        </column>
                        <column className='is-6 has-padding-5-left has-padding-20-left-mobile
                            has-padding-5-right has-padding-15-top'
                        >
                            <p className='psychic-name'>
                                <span>{psychic.speakerName}</span>
                            </p>
                            <p className='is-h5'>
                                <span>{psychic.averageRating}</span>
                                {[0, 1, 2, 3, 4].map(() => (
                                    <img
                                        src='https://gfx.tarot.com/images/daily-pages/daily-icons/keen-star.svg'
                                        width='auto'
                                        height='auto'
                                        loading='lazy'
                                        className='star'
                                        alt='Keen Psychic Rating Stars'
                                    />
                                ))}
                            </p>
                            <p className='is-h6 has-margin-15-left has-margin-10-bottom'>
                                {psychic.ratingCount.toLocaleString()} REVIEWS
                            </p>
                            <button className='is-pill'>CHAT NOW</button>
                        </column>
                    </row>
                </a>
            </column>
        );
    }
}

const mapStateToProps = (state) => ({
    psychics: state.keen,
});

const mapDispatchToProps = (dispatch) => ({
    requirePsychics: () => dispatch({
        type: 'keen:init',
        payload: {
            tid: tid,
            size: 8,
        },
    }),
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);